<div #scrollable data-test-id="scrollable" class="w-full h-full">
  <virtual-scroller
    #scroller
    class="h-full w-full"
    [items]="itemIds"
    [parentScroll]="parentScroll ? parentScroll : scrollable"
    [enableUnequalChildrenSizes]="true"
    [bufferAmount]="virtualScrollBuffer"
  >
    <div #container class="items-container">
      @for (itemId of scroller.viewPortItems; track itemId) {
        @if (createItemTemplateContext(itemId); as itemContext) {
          <app-virtual-scroll-item
            class="{{ gapClass }}"
            [id]="itemId"
            [item]="itemContext.item"
            [itemTemplate]="itemTemplate"
            [itemContext]="itemContext"
            [ngClass]="{
              'focused-via-scroll': itemContext.isFocusedViaScroll,
            }"
            (sizeChange)="scroller.invalidateCachedMeasurementForItem(itemId)"
          ></app-virtual-scroll-item>
        }
      }
    </div>
  </virtual-scroller>
</div>
